import { BenchmarkChart } from "../../../../src/articles/annual-report/2021/03-planing/02-leading-school-benchmarks/chart/chart";
import * as React from 'react';
export default {
  BenchmarkChart,
  React
};